import { getEditLocation } from "../../../core/util/functions";

export const rolesLocation = "/listing/roles";
export const getRoleEditLocation = (id?: string) => getEditLocation(rolesLocation, undefined, id);

export const editRouter = getRoleEditLocation(":roleId?");
